import React, {FC} from 'react';
import {SWRConfig} from 'swr';


export const swrConfig: FC<{ children?: React.ReactNode | undefined }> = (args) => {
  return <SWRConfig value={{
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  }}>{args.children}</SWRConfig>;
};
